import { compress } from 'image-conversion'

const COMPRESSION_THRESHOLD = 4000
const MAX_IMAGE_DIMENSION = 2000

const compressImage = async (file, isLandscape) => {
  const compressionConfig = {
    quality: 1,
    type: file.type,
  }

  if (file.size > COMPRESSION_THRESHOLD * 1000) {
    let compressed

    if (isLandscape) {
      compressed = await compress(file, {
        ...compressionConfig,
        width: MAX_IMAGE_DIMENSION,
      })
    } else {
      compressed = await compress(file, {
        ...compressionConfig,
        height: MAX_IMAGE_DIMENSION,
      })
    }

    return new File([compressed], file.name, { type: file.type })
  }

  return file
}

export { compressImage }
